import { type Editor, NodeViewWrapper } from '@tiptap/react'
import { useCallback, useState } from 'react'
import { Button } from '#app/components/ui/button.tsx'
import { Input } from '#app/components/ui/input.tsx'

export const YouTubeVideoPre = ({
	getPos,
	editor,
}: {
	getPos: () => number
	editor: Editor
}) => {
	const [id, setId] = useState('')
	const onAddVideoId = useCallback(
		(videoId: string) => {
			if (videoId) {
				editor
					.chain()
					.setYoutubeVideo({
						src:
							videoId.startsWith('https://') ||
							videoId.includes('youtube.com') ||
							videoId.includes('youtu.be')
								? videoId
								: `https://www.youtube.com/watch?v=${videoId}`,
						width: 540,
						height: 360,
					})
					.deleteRange({ from: getPos(), to: getPos() })
					.focus()
					.run()
			}
		},
		[getPos, editor],
	)

	return (
		<NodeViewWrapper>
			<div className="m-0 flex items-center gap-2 px-xxxs" data-drag-handle>
				<Input
					name="youtube-video-id"
					type="text"
					placeholder="Escribe el ID del video de YouTube, o su URL"
					onChange={(e) => setId(e.target.value)}
					value={id}
				/>
				<Button
					disabled={!id}
					onClick={() => {
						onAddVideoId(id)
					}}
				>
					Añadir
				</Button>
			</div>
		</NodeViewWrapper>
	)
}

export default YouTubeVideoPre
